import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-page" }
const _hoisted_2 = { class: "title-inner" }
const _hoisted_3 = { class: "mb-16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_ImportModal = _resolveComponent("ImportModal")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, { title: "Загрузка данных из Swagger" }),
    (_ctx.isAccessAllowed)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.importConfig, (configItem) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: configItem.title
          }, [
            _createElementVNode("h3", _hoisted_2, _toDisplayString(configItem.title), 1),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_ButtonComponent, {
                mod: "gradient-bg",
                disabled: _ctx.importInProgress,
                onClick: ($event: any) => (_ctx.importExcel(configItem))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(!_ctx.importInProgress ? `Загрузить из ${configItem.fileType}` : 'Загрузка...'), 1)
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ])
          ], 64))
        }), 128))
      : _createCommentVNode("", true),
    _createElementVNode("section", null, [
      _createVNode(_component_ModalComponent, {
        modelValue: _ctx.importModal,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.importModal) = $event)),
        title: "Импорт файла",
        onClose: _ctx.closeModal
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ImportModal, {
            acceptType: _ctx.getMimeType,
            onDoimport: _ctx.doImport,
            onClose: _ctx.closeModal
          }, null, 8, ["acceptType", "onDoimport", "onClose"])
        ]),
        _: 1
      }, 8, ["modelValue", "onClose"])
    ])
  ]))
}